import moment from "moment";
import "moment/locale/it";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import "./App.scss";
import AppRouter from "./AppRouter";
import Loader from "./common/components/loader";
import { store } from "./core/store";

function App() {
	moment.locale("it");

	return (
		<Provider store={store}>
			<AppRouter />
			<Loader />
			<ToastContainer
				position="top-center"
				autoClose={5000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
			/>
		</Provider>
	);
}

export default App;
